import { post } from '../axios'
import { comment } from './comment'
import { StoreInput } from './input/store-input'

export function storeComment(candidateId: string) {
    return (input: StoreInput) => post(comment, `/candidates/${candidateId}/comments`, input)
}
